<template>
    <div>
        <v-card v-if="true">

            <v-card-title class="modal_title py-5 mb-4">
                    <v-row class="d-flex justify-space-between">
                        Vista previa para la impresión de la evaluación
                        <v-btn color="warning" small class="ml-3" @click="printEval"> Imprimir </v-btn>
                <v-spacer></v-spacer>
                <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                    dark>fa-times</v-icon></v-btn>
            </v-row>
            </v-card-title>

            <v-card-text class="px-16" ref="testHtml">
                <div class="text-center pt-10">
                    <h1 style="font-size: 25px;">Evaluación</h1>
                    <br>
                </div>
                <ul style="list-style: none;">
                    <li v-for="(data,index) in parametros" :key="data.id">
                        <h2 class="pt-10 pb-10"> {{ index + 1 }}. {{ converTextFromHtml(data.pregunta) }} </h2>
                        <template v-if="data.id_tipo_pregunta === 'PU'">
                            <div v-for="item of data.respuesta" :key="item.id">
                                <input type="radio" disabled>
                                <label style="font-size: 20px;"> {{ formatLabel(item.respuesta) }} </label><br>
                            </div>                                   
                        </template>

                        <template v-if="data.id_tipo_pregunta === 'PM'">
                            <div v-for="item of data.respuesta" :key="item.id">
                                <input type="checkbox" disabled>
                                <label style="font-size: 20px;"> {{ formatLabel(item.respuesta) }} </label><br>
                            </div>  
                        </template>
                        
                        <template v-if="data.id_tipo_pregunta === 'PV'">
                            <div v-for="item of data.respuesta" :key="item.id">
                                <input type="radio" disabled>
                                <label style="font-size: 20px;"> {{ formatLabel(item.respuesta) }} </label><br>
                            </div>    
                        </template>

                        <template v-if="data.id_tipo_pregunta === 'PD'">
                                <v-textarea class="pa-0" label="Ingrese Respuesta:" title="editar" :disabled="true" rows="3"
                                v-model="respuestaPD">
                                </v-textarea>
                        </template>
                    </li>
                </ul>

            </v-card-text>
        </v-card>
    </div>
</template>

<script>

    import jsPDF from "jspdf";
    import html2canvas from 'html2canvas';
    export default {
        name: 'imprimirEvaluacion',
        props:{
            parametros:{
                type:Array
            },
            estado:{
                type:Boolean
            },
         },
        data() {
            return {  
                usetitle:'<span style="font-size:36px">Ingrese un titulo</span>',
                respuestaPU: "",
                respuestaPM: [],
                respuestaPV: "",
                respuestaPD: "",
            };
        },
        mounted() {
            // this.printEval();
        },       
        watch: {            
            estado(val) {              
                if(val){
                    // this.printEval();
                }else{   
                    console.log('false');                 
                }
            },         
        },
        methods: {
            /** 
             ____________________________________
            |          MÉTODO IMPRIMIR         */
            async printEval(){
                
                    let doc = new jsPDF({
                        orientation: 'p',
                        unit: 'px',
                        format: 'a4',
                        hotfixes: ['px_scaling'],
                    });
                    const testHtml = this.$refs.testHtml;

                    html2canvas(testHtml).then(canvas => {
                        const imgData = canvas.toDataURL('image/png');
                        const imgWidth = doc.internal.pageSize.getWidth(); // A4 width in mm
                        const pageHeight = doc.internal.pageSize.getHeight(); // A4 height in mm
                        const imgHeight = (canvas.height * imgWidth) / canvas.width;
                        let heightLeft = imgHeight;
                        let position = 1;

                        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;

                        while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        doc.addPage();
                        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                        }

                        doc.save('evaluacion.pdf');
                    });
            },
            /** 
             _________________________________________________
            |          MÉTODO EXTRAER HTML A TEXTO         */
            converTextFromHtml(htmlString) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                return this.formatLabel(doc.body.textContent) || "";
            },
            /** 
             ____________________________________________________
            |          MÉTODO LABEL PRIMERA MAYUSCULA         */
            formatLabel(text) {
                if (!text) return '';
                return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            },
        }          
    }
</script>